var _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlibaba(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 10,
    y: 45,
    fontFamily: "Arial, sans-serif",
    fontSize: 38,
    fontWeight: "bold",
    fill: "currentColor"
  }, "Alibaba")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlibaba);
export default __webpack_public_path__ + "static/media/alibaba.ef8dfda7a8b8ea29dbb2b907e4d51cde.svg";
export { ForwardRef as ReactComponent };